<template>
  <div class="main" style="position: relative">
    <div v-show="!isToggle" class="phone-login">
      <a-form-model id="formLogin" ref="form" :model="form" :rules="rules" class="user-layout-login">
        <a-alert
          v-if="isLoginError"
          :after-close="handleCloseLoginError"
          :message="loginErrorInfo"
          closable
          showIcon
          style="margin-bottom: 24px"
          type="error"
        />
        <h3 v-if="!isLoginPasword">验证码登录</h3>
        <h3 v-else>超管登录</h3>
        <!-- <div class="scan">
          <a-icon type="safety-certificate" theme="filled" />
          <span>扫码登录更安全</span>
        </div> -->
        <!-- <img @click="toggleLogin" class="img-scan1" src="../../assets/icons/bgcode.svg" /> -->
        <a-form-model-item prop="corpid">
          <a-input ref="userNameInput" disabled value="众合诚">
            <!-- <a-input ref="userNameInput" value="捷云智慧" disabled></a-input> -->
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>

        <template v-if="isLoginPasword">
          <a-form-model-item prop="username">
            <a-input v-model="form.username" placeholder="请输入账号" size="large">
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="user" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item prop="password">
            <a-input-password v-model="form.password" placeholder="请输入密码" size="large">
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="security-scan" />
            </a-input-password>
          </a-form-model-item>
          <a-row v-if="captchaOnOff" :gutter="16">
            <a-col :span="16">
              <a-form-model-item prop="code">
                <a-input v-model="form.code" autocomplete="off" placeholder="请输入验证码" size="large" type="text">
                  <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="security-scan" />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <img :src="codeUrl" class="img-code" @click="changeImg" />
            </a-col>
          </a-row>
        </template>

        <template v-else>
          <a-form-model-item prop="phone">
            <a-input v-model="form.phone" placeholder="请输入手机账号" size="large">
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="phone" />
            </a-input>
          </a-form-model-item>
          <a-row v-if="captchaOnOff" :gutter="16">
            <a-col :span="16">
              <a-form-model-item prop="code">
                <a-input v-model="form.code" autocomplete="off" placeholder="请输入验证码" size="large" type="text">
                  <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="security-scan" />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-button
                :disabled="btn.disabled"
                :type="btn.type"
                style="height: 39px; width: 110px; font-size: 12px; background-color: var(--ThemeColor); border: none"
                @click="getVerificationCode"
              >
                {{ btn.text }}
              </a-button>
            </a-col>
          </a-row>
        </template>

        <a-form-item style="margin-top: 24px">
          <a-button
            :disabled="logining"
            :loading="logining"
            class="login-button"
            htmlType="submit"
            size="large"
            type="primary"
            @click="handleSubmit">
            登录
          </a-button>
        </a-form-item>
        <div class="box">
          <a-tooltip>
            <template slot="title">企业微信扫码登录</template>
            <a-button :href="'https://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp" class="WeChatBtn"></a-button>
            <!-- <a-button
              class="WeChatBtn"
              :href="'http://estate.jetcloudtech.com/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp"
            ></a-button> -->
          </a-tooltip>
        </div>
      </a-form-model>
      <div class="super-btn" @click="toggleLoginType">
        <div class="icon-super"></div>
        <div class="super-text">
          <span v-if="!isLoginPasword">超</span>
          <a-icon v-else slot="prefix" type="phone" />
        </div>
      </div>
    </div>

    <div v-show="isToggle" class="scan-login">
      <div class="if-box">
        <!-- <iframe
          :src="'http://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp"
          class="qr-iframe"
          scrolling="no"
          frameborder="no"
        >
        </iframe> -->
        <a-button :href="'https://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp" type="link">企业微信登录</a-button>
      </div>

      <!-- <div class="scan-tips">
        <a-icon type="safety-certificate" theme="filled" />
        <span>请使用企业微信扫码登录更安全</span>
      </div> -->
      <!-- <svg
        t="1647956343685"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="18346"
        width="100"
        height="100"
        color="#fff"
        @click="toggleLogin"
      >
        <path
          d="M746.666667 85.333333c64.8 0 117.333333 52.533333 117.333333 117.333334v618.666666c0 64.8-52.533333 117.333333-117.333333 117.333334H277.333333c-64.8 0-117.333333-52.533333-117.333333-117.333334V202.666667c0-64.8 52.533333-117.333333 117.333333-117.333334h469.333334zM597.333333 778.666667H426.666667a32 32 0 0 0 0 64h170.666666a32 32 0 0 0 0-64z m149.333334-629.333334H277.333333a53.333333 53.333333 0 0 0-53.333333 53.333334v480h576V202.666667a53.333333 53.333333 0 0 0-53.333333-53.333334z"
          p-id="18347"
        ></path>
      </svg> -->

      <img alt="" src="../../assets/images/password.svg" @click="toggleLogin" />
      <div class="bg-top-right"></div>
    </div>

    <!-- 检测用户登录设备-弹窗 -->
    <a-modal
      v-model="ismodal"
      :centered="true"
      :closable="false"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      title="您设备未授权，请填写下方资料申请!"
      width="469px"
    >
      <a-spin :spinning="spinning">
        <a-form-model ref="form_model" :label-col="{ span: 4 }" :model="form_model" :rules="form_model_rules" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="姓名" prop="name">
            <a-input v-model="form_model.name" :maxLength="7" placeholder="姓名" />
          </a-form-model-item>
          <a-form-model-item label="电话" prop="phone">
            <a-input v-model="form_model.phone" placeholder="手机号码" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
            <a-button type="primary" @click="submit_model">提交</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <!-- 检测用户登录设备-弹窗2 -->
    <a-modal
      v-model="ismodal2"
      :centered="true"
      :closable="false"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      class="modal"
      width="500px">
      <div class="ismodal_data">
        <div v-if="ismodal_data === '999'" class="warning-model">
          <a-icon style="color: red; font-size: 50px; font-weight: 700; margin-right: 10px" type="check-circle" />
          <span>您的申请已提交，请耐心等待！</span>
        </div>
        <div v-if="ismodal_data === '1'" class="warning-model">
          <a-icon style="color: red; font-size: 50px; font-weight: 700" type="warning" />
          <span>您的设备登录申请待审核中，请联系管理员！</span>
        </div>
        <div v-if="ismodal_data === '2'" class="warning-model">
          <a-icon style="color: red; font-size: 50px; font-weight: 700" type="warning" />
          <span>您的设备登录申请正在审核中！请耐心等待！</span>
        </div>
        <div v-if="ismodal_data === '4'" class="warning-model">
          <a-icon style="color: red; font-size: 50px; font-weight: 700" type="warning" />
          <span>您的设备登录申请被驳回！请联系管理员或重新申请！</span>
        </div>
        <div v-if="ismodal_data === '4'" style="text-align: center; margin-top: 30px">
          <a-button type="primary" @click="goModelFn">重新申请</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { checkMacAdress, getCodeImg, getCodePhone, getLoginStatus } from '@/api/login'
import { ACCESS_TOKEN, LOGIN_PASSWORD, LOGIN_REMEMBERME, LOGIN_USERNAME } from '@/store/mutation-types'
import storage from 'store'
import { userSeeRecord } from '@/api/system/houses/house.js'
import { sysList } from '@/api/setting/sys'

let timer
export default {
  components: {},
  data () {
    // 电话号码正则
    const validatePhone = async (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === undefined || value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号码!'))
      } else {
        callback()
      }
    }
    return {
      // 设备检测
      ismodal: false,
      ismodal2: false,
      ismodal_data: '',
      phone_modal_msg: '', // 手机扫码登录时没有权限的提示文字
      spinning: false,
      form_model: {
        corpId: '',
        name: '',
        phone: ''
      },
      form_model_rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      },

      btn: {
        type: 'primary',
        text: '获取验证码',
        time: 120,
        disabled: false
      },
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        // corpId: 'wp1a3ABwAAWQtda3sIq26AgOKIYWkn4A', // 正式服
        // corpId: 'wwdd4205e78119d40c', // 测试
        corpId: 'wwbca83946cfdc2782', // 正式
        username: 'admin',
        password: '',
        // phone: '18981818883',
        phone: '',
        // phone: '13739477352',
        code: undefined,
        uuid: '',
        rememberMe: false
      },
      rules: {
        username: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      timeStamp: undefined,
      logining: false,
      captchaOnOff: true,
      isToggle: false, // 是否切换登录方式
      codeTime: 20,
      intervalCodeTime: null,
      isLoginPasword: false // 登录密码方式
    }
  },

  created () {
    this.getLoginStatus()
    this.timeStamp = new Date().getTime()
    this.getStorage()
    // if (this.$route.query.token != undefined) {
    //   storage.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000)
    //   this.loginSuccess(this.$route.query)
    // }
    // console.log('---日志')
    // console.log(this.$route.query)
    if (this.$route.query.code === '0' && this.$route.query.token) {
      storage.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000)
      this.loginSuccess(this.$route.query)
    } else if (this.$route.query.code === '1' && this.$route.query.msg) {
      this.$message.error(this.$route.query.msg, 6)
    }
    this.$store.commit('SET_CORPID', this.form.corpId)
    // this.getCode()
  },

  methods: {
    goModelFn () {
      this.ismodal = true
      this.ismodal2 = false
    },
    // 设备权限检测
    async getLoginStatus () {
      const { code, data } = await getLoginStatus({ corpId: this.form.corpId })
      console.log(code, data, '设备权限检测')
      if (code === 200 && data === '0') {
        this.ismodal = true
      } else if ((code === 200 && data === '1') || data === '2' || data === '4') {
        this.ismodal_data = data
        this.ismodal2 = true
      } else {
        this.ismodal = false
      }
    },
    // 弹窗信息提交
    submit_model () {
      this.spinning = true
      this.$refs.form_model.validate((valid) => {
        if (valid) {
          this.form_model.corpId = this.form.corpId
          checkMacAdress({ ...this.form_model }).then((res) => {
            if (res.code === 200) {
              this.ismodal_data = '999'
              this.ismodal2 = true
              this.ismodal = false
              this.spinning = false
            }
          })
        }
      })
    },

    toggleLogin () {
      //  localStorage.setItem('scrollTop', 0)
      this.isToggle = !this.isToggle
      if (this.isToggle) {
        this.getScanCodeTime()
      } else {
        clearInterval(this.intervalCodeTime)
      }
    },
    getCode () {
      getCodeImg({ corpId: this.form.corpId }).then((res) => {
        this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff
        if (this.captchaOnOff) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.uuid = res.data.uuid
        }
      })
    },
    getPhoneCode () {
      const that = this
      getCodePhone({
        phone: this.form.phone,
        corpId: this.form.corpId
      })
        .then((res) => {
          if (res.code === 200) {
            that.$message.success('发送成功')
          } else {
            that.$message.error(res.msg)
          }
        })
        .catch((err) => {
          if (timer) {
            clearInterval(timer)
          }
          that.btn.text = '获取验证码'
          that.btn.type = 'primary'
          that.btn.disabled = false
          that.btn.time = 120
        })
    },
    getStorage () {
      const username = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (username) {
        this.form = {
          username: username,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe (e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout', 'PhoneLogin', 'CodeLogin']),
    handleSubmit () {
      this.logining = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.username)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          const port = this.isLoginPasword ? this.Login : this.PhoneLogin
          let params = {}
          if (this.isLoginPasword) {
            params = {
              corpId: this.form.corpId,
              username: this.form.username,
              password: this.form.password,
              code: this.form.code,
              uuid: this.form.uuid,
              rememberMe: this.form.rememberMe
            }
          } else {
            params = {
              corpId: this.form.corpId,
              phone: this.form.phone,
              code: this.form.code,
              uuid: this.form.uuid,
              rememberMe: this.form.rememberMe
            }
          }
          port(params)
            .then((res) => this.loginSuccess(res))
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.logining = false
            })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    getVerificationCode () {
      const that = this
      if (that.btn.disabled) {
        return
      } else {
        // 发送验证码 TODO
        this.getPhoneCode()
        that.btn.disabled = true
        that.btn.time = that.btn.time - 1
        that.btn.text = '重新获取(' + that.btn.time + 's)'
        that.btn.type = ''
      }
      timer = setInterval(function () {
        if (that.btn.time > 0) {
          that.btn.time = that.btn.time - 1
          that.btn.text = '重新获取(' + that.btn.time + 's)'
          that.btn.type = ''
        } else {
          clearInterval(timer)
          that.btn.text = '获取验证码'
          that.btn.type = 'primary'
          that.btn.disabled = false
          that.btn.time = 120
        }
      }, 1000)
    },
    getCompany () {
      const params = { pageNum: 1, pageSize: 1 }
      sysList(params).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.total = resData.total
          if (this.total > 0) {
            const company = resData.records ? resData.records[0] : {}
            localStorage.setItem('companyInfo', JSON.stringify(company))
          }
        }
      })
    },
    async loginSuccess (res) {
      // 判断登录用户是否有查看但未跟进的信息，如有，则跳转至相应页面
      const RES = await userSeeRecord()
      this.getCompany()
      const isFollowUpObj = RES.data
      this.$store.commit('SET_IS_FOLLOWUP_OBJ', isFollowUpObj)

      if (isFollowUpObj && isFollowUpObj.isFollowUp === 'N') {
        if (isFollowUpObj.rentSaleType === '1') {
          // -------------------租
          if (isFollowUpObj.resourceType === '1') {
            this.$router.push({
              path: '/houses/detail/index', // 房源详情
              query: {
                id: isFollowUpObj.resourceId,
                formTitle: '出租详情'
              }
            })
          } else {
            this.$router.push({
              path: '/tourist/details', // 客源详情
              query: {
                id: isFollowUpObj.resourceId
              }
            })
          }
        } else {
          // ------------------------------------------------------售
          if (isFollowUpObj.resourceType === '1') {
            this.$router.push({
              path: '/houses/detail/sell', // 房源详情
              query: {
                id: isFollowUpObj.resourceId,
                formTitle: '售房详情'
              }
            })
          } else {
            this.$router.push({
              path: '/tourist/sellDetails', // 客源详情
              query: {
                id: isFollowUpObj.resourceId
              }
            })
          }
        }

        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来,请完成跟进信息`
          })
        }, 1000)
        this.handleCloseLoginError()
      } else if (res && res.init === 1) {
        // 判断登录用户有无完善个人基本信息
        this.$router.push({ path: '/account/settings' })
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来,请完善个人信息`
          })
        }, 1000)
        this.handleCloseLoginError()
      } else {
        this.$router.push({ path: '/' })
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',

            description: `${timeFix()}，欢迎回来`
          })
        }, 1000)
        this.handleCloseLoginError()
      }
    },
    requestFailed (err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
    },
    handleCloseLoginError () {
      this.isLoginError = false
      this.loginErrorInfo = ''
    },
    /***
     *定时器调用扫码登录是否过期
     */
    getScanCodeTime () {
      const that = this
      that.intervalCodeTime = setInterval(function () {
        if (that.codeTime > 0) {
          that.codeTime = that.codeTime - 1
          that
            .CodeLogin(that.timeStamp)
            .then((res) => that.loginSuccess(res))
            .finally(() => {
              that.logining = false
            })
        } else {
          clearInterval(that.intervalCodeTime)
          that.btn.time = 20
        }
      }, 1000)
    },
    /**
     * @description: 切换登录方式
     * @return {*}
     * @Author: wangZhan
     */
    toggleLoginType () {
      this.isLoginPasword = !this.isLoginPasword
      console.log(this.isLoginPasword, 'this.isLoginPasword')
      if (this.isLoginPasword) {
        this.getCode()
      }
    },
    changeImg () {
      this.getCode()
    }
  }
}
</script>
<style lang="less" scoped>
// 手机登录
.qr-iframe {
  width: 100%;
  height: 100%;
  display: inline;
  position: absolute;
  z-index: 1;
  top: -34px;
  left: -36px;
}

.if-box {
  position: relative;
  height: 400px;
  width: 360px;
  overflow: hidden;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
}

.phone-login {
  position: relative;
  overflow: hidden;
  border-radius: 10px;

  .user-layout-login {
    padding: 40px 20px;
    position: relative;

    .scan {
      color: var(--ThemeColor);
      width: 180px;
      height: 36px;
      background-color: var(--MenuBgColor);
      // opacity:0.2;
      display: flex;
      align-items: center;
      position: absolute;
      top: 10px;
      left: 140px;

      & > i {
        font-size: 20px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }

    .img-scan1 {
      width: 40px;
      position: absolute;
      top: 0px;
      right: 0px;
      cursor: pointer;
    }

    & > h3 {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 30px;
      font-weight: 540;
    }

    label {
      font-size: 14px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
      border: none;
      background-color: var(--ThemeColor);
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .register {
        float: right;
      }
    }

    .get-check-box {
      width: 100%;
      height: 40px;
      background-color: var(--ThemeColor);
    }

    .box {
      height: 20px;
      position: relative;

      .WeChatBtn {
        border: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 30px;
        height: 30px;
        background: url('../../assets/images/login/weixin.png') no-repeat;
        background-size: 150px;
        background-position: -82px -36px;
      }
    }
  }

  .bottom {
    height: 60px;
    background-color: #e8f3ff;
    padding-left: 20px;
    line-height: 60px;

    .divider {
      margin: 0 20px;
    }
  }
}

//扫码登录
.scan-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 432px;

  .img-scan {
    width: 50%;
    margin-top: 60px;
  }

  .scan-tips {
    margin-top: 30px;
    color: var(--ThemeColor);
    width: 60%;
    height: 36px;
    background-color: #d6e9ff;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    & > i {
      font-size: 20px;
      margin-left: 10px;
      margin-right: 4px;
    }
  }

  .icon {
    width: 40px;
    height: 50px;
    color: #fff;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
  }

  .bg-top-right {
    position: absolute;
    top: 0px;
    right: 0px;
    box-sizing: border-box;
    border: 28px solid var(--ThemeColor);
    border-color: var(--ThemeColor) var(--ThemeColor) #fff #fff;
  }

  img {
    width: 25px;
    position: absolute;
    top: 2px;
    z-index: 200;
    right: 2px;
  }

  // img{
  //   width: 30px;
  // }
}

.frame_cnt_inside_Small {
  margin: 0 !important;
}

.frame_cnt_inside {
  margin: 0 !important;
}

/deep/ html {
  background-color: #fff !important;
}

.ismodal_data {
  height: 200px;
  line-height: 100px;

  .warning-model {
    color: black;
    font-weight: 700;
    display: flex;
    align-items: center;
    font-size: 16px;
  }
}

.super-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;

  .icon-super {
    border-style: solid;
    border-color: transparent;
    border-width: 40px 0 40px 40px;
    border-left-color: var(--ThemeColor);
    transform: rotateZ(45deg);
    position: absolute;
    right: -8px;
    bottom: -33px;
  }

  .super-text {
    position: absolute;
    right: 5px;
    bottom: 10px;
    color: white;
  }
}

.img-code {
  height: 40px;
}
</style>
